import React, { useContext, useState } from "react";
import CustomLayout from "../../Layout/CustomLayout";
import ReceptionistSideMenu from "../../Layout/CustomLayout/ReceptionistSideMenu";
import useQuery from "../../../hooks/useQuery";
import { Image } from "antd";
import { UserContext } from "../../../context/UserContext";
import OutPatientTable from "./OutPatientTable";
import ReceptionistPageTitle from "../ReceptionistPageTitle";
import "./Outpatients.css";

const Outpatients = ({ refresh }) => {
  const params = useQuery();
  const { userDetails } = useContext(UserContext);
  const [patientCount, setPatientCount] = useState(null);

  return (
    <CustomLayout
      layoutClassName="reception-layout"
      sideContent={
        params?.patient ? null : <ReceptionistSideMenu refresh={refresh} />
      }
      header={
        params?.patient ? (
          <>
            {userDetails?.activeOrg?.org_logo ? (
              <Image
                preview={false}
                src={userDetails?.activeOrg?.org_logo}
                alt="Logo"
                style={{
                  width: "40px",
                  marginTop: "10px",
                }}
              />
            ) : (
              userDetails?.activeOrg?.org_name
            )}
          </>
        ) : (
          <div className="outpatients-page-header flex-start" style={{ width: "100%" }}>
            <ReceptionistPageTitle count={patientCount}>
              Out Patients
            </ReceptionistPageTitle>
          </div>
        )
      }
    >
      <OutPatientTable
        facilityId={userDetails?.activeOrg?.id}
        onCountChange={setPatientCount}
      />
    </CustomLayout>
  );
};

export default Outpatients;
